<template>
  <div id="app" :class="mainClassVal" v-if="initialized == true">
    <v-dialog
      @before-opened="dialogEvent('before-open')"
      @before-closed="dialogEvent('before-close')"
      @opened="dialogEvent('opened')"
      @closed="dialogEvent('closed')"
    />
    <!-- <p>Is it Idle? - {{ isIdle }}</p> -->
    <nav-header2 v-if="navType === '02'"></nav-header2>
    <nav-header3 v-else-if="navType === '03'"></nav-header3>
    <nav-header v-else></nav-header>
    <transition-page>
      <router-view :key="$route.fullPath" />
    </transition-page>
    <section id="main-call-ui" v-if="isFooterShow === true">
      <nav-footer></nav-footer>
    </section>
    <Menu></Menu>
    <div class="loading-wrap" style="display:none;">
      <div class="loading">
        <img src="@/assets/loging_4.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
window.popStateDetected = false;
window.onpopstate = function() {
  window.popStateDetected = true;
};

import TransitionPage from "./components/common/TransitionPage";
import NavHeader from "./components/common/NavHeader";
import NavHeader2 from "./components/common/NavHeader2";
import NavHeader3 from "./components/common/NavHeader3";
import NavFooter from "./components/common/NavFooter";
import Menu from "./components/common/Menu";

import { mapState } from "vuex";

export default {
  beforeCreate() {
    /**
     * 앱의 최초 실행 or 새로고침 시
     * 브라우저 정보는 userAgent로 부터 조회
     */
    const si = this.$Util.browserDetect(
      this.$CONST.dataBrowser,
      this.$CONST.dataOS
    );



    this.$store.commit("system/setSystem", si);

    const entry = performance.getEntriesByType("navigation")[0];
    if (entry) {
      if (entry.type === "reload") {
        this.isReload = true;
      }
    } else {
      if (window.performance.navigation.type == 1) {
        this.isReload = true;
      }
    }

    this.$store.commit("system/setReload", this.isReload); //새로고침여부

    if (!this.isReload) {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let connKey = params.get("key");
      let aniNo = params.get("ani");

      if (!this.$Util.isEmpty(connKey) && !this.$Util.isEmpty(aniNo)) {
        //접속키가 있을경우
        this.$store.commit("document/setConnectKey", connKey); //sessionStore에 저장함.
        this.$store.commit("document/setConnectAniNo", aniNo); //sessionStore에 저장함.
        this.$Util.setStore("connKey", connKey);
        this.$Util.setStore("aniNo", aniNo);
      }
    } else {
      //새로고침일때
      let keyVal = this.$Util.getStore("connKey");
      let aniVal = this.$Util.getStore("aniNo");

      this.$store.commit("document/setConnectKey", keyVal); //sessionStore에 저장함.
      this.$store.commit("document/setConnectAniNo", aniVal); //sessionStore에 저장함.

      // 서류제출 목록 스토어 저장
      let documents = this.$Util.getStore("resultDocuments");
      this.$store.commit("document/setResultDocuments", documents);

      // SMS 인증 여부 저장
      let confirmSMS = this.$Util.getStore("confirmSMS");
      this.$store.commit("document/setConfirmSMS", confirmSMS);

      if (this.$Util.isEmpty(keyVal) || this.$Util.isEmpty(aniVal)) {
        this.documentCloseService(true);
        return false;
      }
    }
  },
  created() {
  },
  mounted() {
    //초기 진입시 초기화
    this.initApp();
  },
  onIdle() {
    if (
        this.$route.name == "VARS20001" || // 문자인증 페이지
        this.$route.name == "VARS20002" // 서류제출 페이지
    ){
      this.$alert({
        contents:
            "장시간 이용이 없어 안전한 서비스 이용을 위해 모바일 서류접수 서비스가 종료되었습니다.",
        btn_type: this.$CONST.BTN_TP_OK
      })
          .then(() => {
            //서비스종료
            this.$replace("VARS20012");
          })
          .catch(function(err) {
            this.log_error(err);
          });
    }
  },
  onActive() {},
  data() {
    return {
      transitionName: "slide-left",
      isReload: false,
      mainClassVal: ""
    };
  },
  components: {
    TransitionPage,
    NavHeader,
    NavHeader2,
    NavHeader3,
    NavFooter,
    Menu
  },
  computed: {
    ...mapState("manageUI", {
      navType: state => state.navType
    }),
    ...mapState("manageUI", {
      mainClass: state => state.mainClass,
      isFooterShow: state => state.isFooterShow
    }),
    ...mapState("system", {
      initialized: state => state.initialized
    })
  },
  watch: {
    initialized: {
      //초기화가 완료되었을때 한번 호출됨.
      handler: function(newVal, oldVal) {
        if (newVal != oldVal && newVal == true) {
          console.log("초기화 완료되면 호출!")
        }
      },
      deep: true
    },
    mainClass(val) {
      this.mainClassVal = val;
    }
  },
  methods: {
    initApp() {

      const connKey = this.$store.getters["document/getConnectKey"];
      this.$store.commit("system/setInitApp", true);

      if (this.$Util.isEmpty(connKey)) {
        //최초 접속키가 없으면 오류 처리함.
        this.$replace("VARS20012");
        return;
      }


    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: 300ms;
}

.slide-enter-to {
  position: relative;
  left: 0;
}

.slide-leave {
  position: absolute;
}

.slide-enter {
  left: -100vw;
  position: absolute;
}

.slide-leave-to {
  right: -100vw;
}

/* .fade-enter-active, .fade-leave-active {
transition: opacity .75s ease;
}
.fade-enter, .fade-leave-active {
opacity: 0;
}
.child-view {
position: absolute;
transition: all .75s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
opacity: 0;
-webkit-transform: translate(30px, 0);
transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
opacity: 0;
-webkit-transform: translate(-30px, 0);
transform: translate(-30px, 0);
} */
</style>
